import Status from 'views/pages/status/Status.jsx';
import AuthSummary from 'views/pages/authSummary/authSummary.jsx';
import deviceAuthSummary from 'views/pages/deviceAuthSummary/deviceAuthSummary.jsx';
import AuthDevice from 'views/pages/authDevice/AuthDevice.jsx';
import UnAuth from 'views/pages/unAuthDevice/UnAuth.jsx';
import CellTower from 'views/pages/cellTower/CellTower.jsx';
import Department from 'views/pages/department/Department.jsx';
import Ap from 'views/pages/ap/Ap.jsx';
import User from 'views/pages/user/User.jsx';
import JobStatus from 'views/pages/jobStatus/JobStatus';

import departmentIcon from 'assets/images/commons/sidebar/department.png';
import statusIcon from 'assets/images/commons/sidebar/status.png';
import authDeviceIcon from 'assets/images/commons/sidebar/auth-device.png';
import unAuthDeviceIcon from 'assets/images/commons/sidebar/unauth-device.png';
import cellTowerIcon from 'assets/images/commons/sidebar/cell-tower.png';
import apIcon from 'assets/images/commons/sidebar/ap.png';
import permissionIcon from 'assets/images/commons/sidebar/permission.png';
import AccessLog from 'views/pages/accessLog/AccessLog';
import userIcon from 'assets/images/commons/sidebar/user-management.png';
import jobStatusIcon from 'assets/images/commons/sidebar/job-status.png';
import accessLogIcon from 'assets/images/commons/sidebar/access-log.png';

import { getUserType } from 'utils/tokenHelper';

/**
 *  routes 객체 설명
 *  {
 *       path: '/department', - path name
 *       name: '지점 관리', - 페이지 제목
 *       icon: departmentIcon, - sidebar 에 표시되는 icon
 *       component: Department, - 사용하는 컴포넌트
 *       layout: '/devices', - 사용하는 레이아웃 (path prefix)
 *       useCell: false, - 기지국 정보 표출 여부 / * 25.01.20 기준 표출 여부 분기 추가
 *     },
 *
 */

export default function getRoutes() {
  const routes = [
    {
      path: '/department',
      name: '지점 관리',
      icon: departmentIcon,
      component: Department,
      layout: '/devices',
      useCell: false,
    },
    {
      path: '/status/:path',
      name: '인증 현황',
      icon: statusIcon,
      component: Status,
      layout: '/devices',
      useCell: false,
    },
    {
      path: '/auth',
      name: '등록 디바이스 관리',
      icon: authDeviceIcon,
      component: AuthDevice,
      layout: '/devices',
      useCell: false,
    },
    {
      path: '/unauth',
      name: '미등록 디바이스 관리',
      icon: unAuthDeviceIcon,
      component: UnAuth,
      layout: '/devices',
      useCell: false,
    },
    {
      path: '/cell',
      name: '기지국 관리',
      icon: cellTowerIcon,
      component: CellTower,
      layout: '/devices',
      useCell: true,
    },
    {
      path: '/ap',
      name: '위치인증 Ap 관리',
      icon: apIcon,
      component: Ap,
      layout: '/devices',
      useCell: false,
    },
    {
      path: '/summary',
      name: '지점별 인증현황 집계',
      icon: statusIcon,
      component: AuthSummary,
      layout: '/devices',
      useCell: false,
    },
    {
      path: '/deviceSummary',
      name: '지점별 단말인증현황 집계',
      icon: statusIcon,
      component: deviceAuthSummary,
      layout: '/devices',
      useCell: false,
    },
    {
      path: '/user',
      name: '유저 관리',
      icon: userIcon,
      component: User,
      layout: '/management',
      useCell: false,
    },
    {
      path: '/jobStatus',
      name: 'Job 현황',
      icon: jobStatusIcon,
      component: JobStatus,
      layout: '/management',
      useCell: true,
    },
    {
      path: '/accessLog',
      name: '접속 로그',
      icon: accessLogIcon,
      component: AccessLog,
      layout: '/management',
      useCell: false,
    }
  ];

  const userType = getUserType();
  let permittedRoutes = [];

  // SA 모든 페이지 접근 권한 O
  if (userType === 'SARW' || userType === 'SARO') {
    return routes;
  }

  // useCell 에 해당하는 { path: '/cell' }, { path: '/jobStatus' } 표출 X
  if (localStorage.getItem('companyId') === '0000000002') {
    permittedRoutes = routes.filter(route => !route.useCell);
  } else {
    permittedRoutes = [...routes];
  }

  if (userType === 'CDSU') {
    return permittedRoutes;
  } else if (userType === 'CDRW' || userType === 'CDRO') {
    return permittedRoutes.filter(v => v.layout !== '/management');
  }

  return permittedRoutes;
}
